












import Vue from 'vue'
import { LoadingMessages } from '@/common/constants/imageUpload'
export default Vue.extend({
  props: {
    message: {
      type: String as () => LoadingMessages,
      default: LoadingMessages.DEFAULT
    }
  }
})
